import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaSearch } from "react-icons/fa";
import { listarSocios, listarPropiedadesDeSocio } from "../../services/sociosService";
import "./Socios.css";
import notify from "../common/notify";

const SociosList = () => {
  const navigate = useNavigate();
  const [socios, setSocios] = useState([]);
  const [counts, setCounts] = useState({});
  const [busqueda, setBusqueda] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const items = await listarSocios();
        if (!alive) return;
        setSocios(items);

        const pares = await Promise.all(
          items.map(async (s) => {
            const props = await listarPropiedadesDeSocio(s.id);
            return [s.id, props.filter((p) => p.apartadaSocio || p.estado === "apartada_socio").length];
          })
        );
        if (alive) setCounts(Object.fromEntries(pares));
      } catch (e) {
        console.error(e);
        notify.error("No se pudieron cargar los socios");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const filtrados = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    return socios
      .filter((s) => {
        const texto = `${s.nombre || ""} ${s.apellidos || ""} ${s.email || ""} ${s.telefono || ""}`.toLowerCase();
        return texto.includes(q);
      })
      .sort((a, b) => `${a.nombre || ""} ${a.apellidos || ""}`.localeCompare(`${b.nombre || ""} ${b.apellidos || ""}`));
  }, [socios, busqueda]);

  if (loading) return <div className="socios-page"><div className="socios-card">Cargando socios…</div></div>;

  return (
    <div className="socios-page">
      <div className="socios-card">
        <h2 className="socios-title">Gestión de Socios</h2>
        <div className="socios-toolbar">
          <input
            className="socios-input"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Buscar socio por nombre, correo o teléfono..."
          />
          <button className="socios-btn" onClick={() => navigate("/app/socios/nuevo")}>
            <FaPlus /> Nuevo socio
          </button>
        </div>

        <div className="socios-table-wrap">
          <table className="socios-table">
            <thead>
              <tr>
                <th>Socio</th>
                <th>Teléfono</th>
                <th>Correo</th>
                <th>Propiedades apartadas</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map((s) => (
                <tr key={s.id}>
                  <td>{s.nombre || ""} {s.apellidos || ""}</td>
                  <td>{s.telefono || "-"}</td>
                  <td>{s.email || "-"}</td>
                  <td>{counts[s.id] ?? s.propiedadesAsignadasCount ?? 0}</td>
                  <td><span className={`socios-badge ${s.activo === false ? "off" : ""}`}>{s.activo === false ? "Inactivo" : "Activo"}</span></td>
                  <td>
                    <button className="socios-btn secondary" onClick={() => navigate(`/app/socios/${s.id}`)}>
                      <FaSearch /> Ver
                    </button>
                  </td>
                </tr>
              ))}
              {!filtrados.length && (
                <tr><td colSpan="6" style={{ textAlign: "center", opacity: .7 }}>Sin resultados</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SociosList;
